export const navside = function () {
	var $body = $('body'),
		$nav_side = $('#sidenav_JS'),
		$button = $('#navside_JS'),
	 	$opacity	=	$('#opacity_JS'),
   		toggle = true;

   	$nav_side.animate({
		left: '-100%'
	});

	$opacity.on("click",function(){
		hide();
	});

	$nav_side.on("click",".close_JS",function(){
		hide();
	});

	$button.on("click",function(){
		if (toggle === true) {
			$nav_side.animate({
				left: '0',
				transition: 'all 0.3s ease-in-out'
			},'fast');
			$body.css({
				width:	'calc(100% - 250px)',
				transition: 'width 0.3s',
				marginLeft:	'auto',
			});
			$opacity.css('display','block');
			toggle = false;
		} else {
			hide();
			toggle = true;
		}
	});

	$(window).resize( function () {
		hide();
	   	toggle = true;
	})

	function hide() {
		$nav_side.animate({
			left: '-100%',
			transition: 'all 0.3s ease-in-out'
		},'fast');
		$body.css({
			width: '100%',
			transition: 'width 0.3s'
		})
		$opacity.css('display','none');
	}


	// menu

	//closeclose_menu_items()

	function close_menu_items(close) {
		var $close = $(close),
			$item = $close.closest(".sidenav_item_JS"),
			$list = $item.find(".sidenav_item_list_JS"),
			$open = $item.find(".sidenav_item_open_JS");

		$list.slideUp(300);
		$close.hide(10);
		$open.show("fast");
	}


	$nav_side.find(".sidenav_item_JS").on("click",".sidenav_item_close_JS", function(){
		close_menu_items(this);
	} );

	//open
	$nav_side.find(".sidenav_item_JS").on("click",".sidenav_item_open_JS", function(){
		var $this = $(this),
			$item = $this.closest(".sidenav_item_JS"),
			$list = $item.find(".sidenav_item_list_JS"),
			$close = $item.find(".sidenav_item_close_JS");

		$nav_side.find(".sidenav_item_close_JS").each(function(){
			close_menu_items(this);
		});

		$list.slideDown(300);
		$this.hide(10);
		$close.show("fast");
	});

}



// WEBPACK FOOTER //
// ./resources/assets/js/navside.js